export var GroupsSortBy;
(function (GroupsSortBy) {
    GroupsSortBy["UNKNOWN"] = "UNKNOWN";
    /** Default sorting (recent activity, title and member count) */
    GroupsSortBy["DEFAULT"] = "DEFAULT";
    /** Sort by recent activity date. */
    GroupsSortBy["RECENT_ACTIVITY"] = "RECENT_ACTIVITY";
    /** Sort by title. */
    GroupsSortBy["TITLE"] = "TITLE";
    /** Sort by members count. */
    GroupsSortBy["MEMBER_COUNT"] = "MEMBER_COUNT";
})(GroupsSortBy || (GroupsSortBy = {}));
export var AuthorizedGroupCreators;
(function (AuthorizedGroupCreators) {
    AuthorizedGroupCreators["UNKNOWN_POLICY"] = "UNKNOWN_POLICY";
    /** Only Wix Groups Managers can create new groups. */
    AuthorizedGroupCreators["OWNER"] = "OWNER";
    /** All members are allowed to create new groups. */
    AuthorizedGroupCreators["MEMBERS"] = "MEMBERS";
    /** All members can create new groups, but they must be approved by a Wix Groups Managers. */
    AuthorizedGroupCreators["MEMBERS_WITH_APPROVAL"] = "MEMBERS_WITH_APPROVAL";
})(AuthorizedGroupCreators || (AuthorizedGroupCreators = {}));
//# sourceMappingURL=types.impl.js.map